import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ClawHomeApi, ClawHomeApiImpl } from './apis';

export const clawHomeContainer = new ContainerModule((bind) => {
    bind<ClawHomeApi>(ClawHomeApi).to(ClawHomeApiImpl);
});

export { ClawHomeApi } from './apis';
export type { AvailableAgent } from './apis';
